import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    headerTitle: translate({ id: 'settings.personalization.view.headerTitle' }),
    headerDescription: translate({ id: 'settings.personalization.view.headerDescription' }),

    weekStartsWith: translate({ id: 'settings.personalization.view.weekStartsWith' }),

    edit: translate({ id: 'settings.personalization.view.edit' }),
  }))

  return api
}
